// Convocatorias 2024

export const convocatoria001 = [
  {
    nombre: "Convocatoria 01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/CONVOCATORIA 01-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria002 = [
  {
    nombre: "Convocatoria 02-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/CONVOCATORIA 02-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria003 = [
  {
    nombre: "Convocatoria 03-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/CONVOCATORIA 03-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n1 = [
  {
    nombre: "Bases N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/BASES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/JUNTA DE ACLARACIONES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESP.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N1",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N1/FALLO EA-913005999-N1-2024 CARGO ADMINISTRATIVO POR LA PRESTACIÓN DEL SERVICIO DE DISPERSIÓN DE VALES DE DESPENSA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n2 = [
  {
    nombre: "Bases N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/BASES EA-913005999-N2-2024 ALIMENTACION.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/JUNTA DE ACLARACIONES EA-913005999-N2-2024 ALIMENTACIÓN DE PERSONAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/PRESENTACION Y APERTURA DE PROPOSICIONES  EA-913005999-N2-2024 ALIEMTANCION DE PERSONAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N2",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N2/FALLO EA-913005999-N2-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n3 = [
  {
    nombre: "Bases N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/BASES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/JUNTA DE ACLARACIONES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N3",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024/N3/FALLO EA-913005999-N3-2024 ARRENDAMIENTO DE MAQUINARIA, OTROS EQUIPOS Y HERRAMIENTAS (SEGUNDO PROCEDIMIENTO).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n4 = [
  {
    nombre: "Bases N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/BASES EA-913005999-N4-2024 SERVICIO DE TRASLADO DE VALORES.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/JUNTA DE ACLARACIONES EA-913005999-N4-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/APERTURA TECNICA Y ECONOMICA EA-913005999-N4-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N4",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N4/FALLO EA-913005999-N4-2024 TRASLADO DE VALORES (2DO. PROCED.).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n5 = [
  {
    nombre: "Bases N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/BASES EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/JUNTA DE ACLARACIONES EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/APERTURA TECNICA Y ECONOMICA EA-913005999-N5-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N5",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 02-2024/N5/FALLO EA-913005999-N5-2024 SEGUROS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n6 = [
  {
    nombre: "Bases N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/BASES EA-913005999-N6-2024 SERVICIOS DE ACCESO DE INTERNET, REDES Y PROCESAMIENTO DE INFORMACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Junta de Aclaraciones EA-913005999-N6-2024 Servicios de Acceso de Internet, Redes y Procesamiento de Información.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Acta de Presentación y Apertura de Proposiciones EA-913005999-N6-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Fallo N6",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 03-2024/N6/Acta de Fallo EA-913005999-N6-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP001 = [
  {
    nombre: "Convocatoria 01-2024 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CONVOCATORIA 01-2024 OBRA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];


export const lop1 = [
  {
    nombre: "Bases CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/BASES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Catalogo Mudo CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/CATALOGO MUDO CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO PROYECTO FINAL DETALLES CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PLANO PROYECTO FINAL DETALLES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO PROYECTO FINAL PGDA CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PLANO PROYECTO FINAL PGDA CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACUERDO FE DE ERRATAS CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/ACUERDO FE DE ERRATAS CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            // new: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            publicationDate: "2024-22-04",
            new: "www.google.com",
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 01-2024 OBRA/CAASIM-HGO-L.O.P.-01-2024/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2024.pdf",
            // word: "www.google.com",
            
          },
        ],
      },
    ],
  },
];

export const convocatoria004 = [
  {
    nombre: "Convocatoria 04-2024",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/CONVOCATORIA 04-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];


export const n7 = [
  {
    nombre: "Bases N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/BASES EA-913005999-N7-2024 CAPACTACIÓN.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/JUNTA DE ACLARACIONES EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],

      },
    ],
  },
  {
    nombre: "Presentación y Apertura de Proposiciones N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/APERTURA TECNICA ECONOMICA EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N7",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // ecel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 04-2024/N7/FALLO EA-913005999-N7-2024.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  }
];


// export const nx = [
//   {
//     nombre: "Bases NX",
//     documentos: [
//       {
//         nombre: "Archivo",
//         contenido: [
//           {
//             // excel: "www.google.com",
//             pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 0X-2024/NX/",
//             // word: "www.google.com",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     nombre: "Junta de Aclaraciones N5",
//     documentos: [
//       {
//         nombre: "Archivo",
//         contenido: [
//           {
//             // excel: "www.google.com",
//             pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 0X-2024/NX/",
//             // word: "www.google.com",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     nombre: "Presentación y Apertura de Proposiciones N5",
//     documentos: [
//       {
//         nombre: "Archivo",
//         contenido: [
//           {
//             // excel: "www.google.com",
//             pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 0X-2024/NX/",
//             // word: "www.google.com",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     nombre: "Fallo N5",
//     documentos: [
//       {
//         nombre: "Archivo",
//         contenido: [
//           {
//             // excel: "www.google.com",
//             pdf: "/CAASIM/licitaciones/2024/CONVOCATORIA 0X-2024/NX/",
//             // word: "www.google.com",
//           },
//         ],
//       },
//     ],
//   }
// ];
